
define('text!templates/components/customer_note/customer_notes.html',[],function () { return '<div class="list-container">\n\n</div>\n';});

